import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m5.667 1.253-.96-.96-1.414 1.414.96.96 1.414-1.414Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.667 1.253a2 2 0 0 1 0 2.828l-.253.253.96.96L4.96 6.706 4 5.747A2 2 0 0 1 4 2.92l.252-.252 1.415-1.414Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4 13H13a3 3 0 0 0 0-6H1v3.5A5.5 5.5 0 0 0 11.4 13ZM13 9h-1v2h1a1 1 0 1 0 0-2Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m8.04.293.96.96-1.414 1.414-.96-.96L8.04.293Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9 1.253 7.586 2.667l-.253.252a2 2 0 0 0 0 2.829l.96.96 1.414-1.415-.96-.96L9 4.082a2 2 0 0 0 0-2.828Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconComfortTea16 = createIcon(IconComponent);